import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import UserContext from '../tools/contextLib';
import 'bootstrap/dist/css/bootstrap.min.css';
import { browserName, browserVersion } from 'react-device-detect';
import moment from 'moment';
import { Table, Input, Form, FormGroup, Label, Button } from 'reactstrap';

export class RevokeAccess extends Component {
    static displayName = RevokeAccess.name;

    constructor(props) {
        super(props);
        this.state = {
            returnable: [],
            browser: `${browserName}${browserVersion}`,
            ip: "",
            permissionFlag: true,
            revokedList: [],
            optionList: [],
            nameOption: "DEFAULT",
            accessOption: "DEFAULT",
            expOption: "1955-11-05"
        }
        this.getData();
    }

    async getData() {
        const response = await fetch('https://api.ipify.org?format=json', { dataType: 'jsonp' });
        const data = await response.json();
        this.setState({
            ip: data.ip
        })
        this.getUserInfo();
    }

    async getUserInfo() {
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        const response = await fetch('user', { method: 'GET', headers: { 'Authorization': bearerVAR } });
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
        let today = new Date().toISOString().slice(0, 10)
        this.setState({
            returnable: data,
            expOption: today
        }, () => {
            //this.recordComingHere();
            this.testPermission();
            this.getRevoked();
            this.getOptions();
        });

    }

    //async recordComingHere() {
    //    let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
    //    let toSend = {
    //        pagePK: "2042",//1043 in prod
    //        department: this.state.returnable.level,
    //        userPCID: this.state.returnable.pcid,
    //        ip: this.state.ip,
    //        browser: this.state.browser,
    //        userID: this.state.returnable.username
    //    }
    //    const response = await fetch('logging', {
    //        method: 'POST',
    //        headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
    //        body: JSON.stringify(toSend)
    //    });
    //    const data = await response.json();
    //    localStorage.setItem("lastFetch", moment());
    //}

    async testPermission() {
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let toSend = {
            userLevel: this.state.returnable.level,
            pagepk: "1043"//1043 in prod
        }
        const response = await fetch('ValidDepartments', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
        this.setState({
            permissionFlag: data
        })
    }

    async getRevoked() {
        localStorage.setItem("lastFetch", moment());
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let toSend = {
            userLevel: this.state.returnable.level
        }
        const response = await fetch('GetRevokedAccess', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        this.setState({
            revokedList: data
        })
    }

    async getOptions() {
        localStorage.setItem("lastFetch", moment());
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let toSend = {
            userLevel: this.state.returnable.level
        }
        const response = await fetch('RevokeAllOptions', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        this.setState({
            optionList: data
        })
    }

    componentDidMount() {

    }

    async newRevoke(e) {
        e.preventDefault();
        console.log("new revoke");
        const dataInput = new FormData(e.target);
        localStorage.setItem("lastFetch", moment());
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let toSend = {
            userLevel: this.state.returnable.level,
            pcid: dataInput.get("name"),
            access: dataInput.get("access"),
            expdate: dataInput.get("expdate")
        }
        const response = await fetch('AddRevoke', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        this.getRevoked();
    }

    async changeExpDate(e, PK) {
        console.log("change date: " + e + ", " + PK)
        localStorage.setItem("lastFetch", moment());
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let toSend = {
            userLevel: this.state.returnable.level,
            newdate: e,
            pk: PK
        }
        const response = await fetch('ChangeRevokeDate', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        this.getRevoked();
    }

    render() {
        if (this.state.permissionFlag == false) {
            this.props.passNewPage(-1);
        }
        if (this.props.justSwitch == true) {
            this.props.passNewPage(1);
        }
        return (<div>
            <Form className='d-flex' onSubmit={(e) => this.newRevoke(e)}>
                <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
                    <Label>User</Label>
                    <Input type="select" id="name" name="name" value={this.state.nameOption} onChange={(e) => this.setState({ nameOption: e.target.value, accessOption:"DEFAULT" }) }>
                        <option value="DEFAULT" disabled>Select</option>
                        {[...new Set(this.state.optionList.map(user => user.pcid))].map(item => (
                            <option value={item}>{this.state.optionList.find((element) => element.pcid == item).name }</option>
                        )) }
                    </Input>
                </FormGroup>
                {this.state.nameOption != "DEFAULT" && <FormGroup>
                    <Label>Access</Label>
                    <Input type="select" id="access" name="access" value={this.state.accessOption} onChange={(e) => this.setState({accessOption: e.target.value}) }>
                        <option value="DEFAULT" disabled>Select</option>
                        {this.state.optionList.filter((option) => option.pcid == this.state.nameOption).map(item => (
                            <option value={item.access}>{item.access}</option>
                        )) }
                    </Input>
                </FormGroup>}
                {this.state.accessOption != "DEFAULT" && <FormGroup>
                    <Label>Expiration Date</Label>
                    <Input type="date" name="expdate" id="expdate" value={this.state.expOption} onChange={(e) => this.setState({expOption: e.target.value}) } />
                </FormGroup>}
                {this.state.accessOption != "DEFAULT" && <Button type="submit" outline color="success">Submit</Button>}
            </Form><br />
            <Table>
                <thead>
                    <tr>
                        <th>PCID</th>
                        <th>Name</th>
                        <th>Revoked Access</th>
                        <th>Revoked By</th>
                        <th>Expiration Date</th>
                    </tr>
                </thead>
                <tbody>
                    {this.state.revokedList.map(item => (
                        <tr>
                            <td>{item.pcid}</td>
                            <td>{item.firstname} {item.lastname}</td>
                            <td>{item.access}</td>
                            <td>{item.revoker}</td>
                            <td><Input type="date" defaultValue={item.exdate} name="exdate" id="exdate" onChange={(e) => this.changeExpDate(e.target.value, item.pk)} /></td>
                            {/*<td>{item.exdate}</td>*/}
                        </tr>
                    ))}
                </tbody>
            </Table>
        </div>);
    }
}